export default "__VITE_ASSET__8605916b__"